import React from 'react'

const MenHealing = () => {
  return (
    <>
      <div className='flex-c h-margin gray'>
        <h3 className='h-margin'>Men Healing</h3>
        <h3 className='h-margin'>Coming Soon</h3>
      </div>
    </>
  )
}

export default MenHealing